import {createReducer} from 'redux-act';

import {setTryOnVisibility} from 'actions/tryOnVisibility/tryOnVisibility';

export const initialState = false;

export const tryOnVisibility = createReducer({}, initialState).on(
    setTryOnVisibility,
    (state, payload) => payload,
);
